export const appliedFilterPreviewTheme = {
  actions: {
    borderColor: 'palette.neutral.40',
    borderWidth: '1px',
  },
  borderColor: 'palette.neutral.40',
  borderRadius: '8px',
  borderWidth: '1px',
  filterValue: 'palette.tertiary.95',
  name: 'palette.neutral.40',
};
